import apiClient from "./api";
export function login(data, state) {
    console.log(data);
    return apiClient.post(`/v1/client-portal/auth/login`, data, {
        params: {
            pw: state
        }
    });
}
export function logout() {
    return apiClient.post(`/v1/client-portal/auth/logout`);
}
//注册
export function register(data) {
    return apiClient.post(`/v1/client-portal/auth/register`, data);
}
//忘记密码 
export function forgotPassword(data) {
    return apiClient.post(`/v1/client-portal/auth/forgot-password`, data);
}
//验证码
export function sendCode(data) {
    return apiClient.post(`/v1/client-portal/auth/send-code`, data);
}
//重置密码
export function resetPassword(data) {
    return apiClient.post(`/v1/client-portal/auth/reset-password`, data);
}
//重置密码
export function amendPassword(data) {
    return apiClient.post(`/v1/customer/update-password`, data);
}

